<template>
  <div class="flex items-center bg-gray-100 rounded-lg p-1 w-full md:w-auto">
    <button
      @click="decrement"
      :disabled="value <= min"
      class="rounded-md bg-white shadow-sm flex items-center justify-center hover:bg-gray-50 text-gray-600 disabled:opacity-50 transition-all"
      :class="useDropdown ? 'w-12 h-12 md:w-10 md:h-10' : 'w-10 h-10'"
    >
      <Minus :size="16" />
    </button>
    <!-- Mobile: numeric keypad input -->
    <input
      v-if="useDropdown"
      :value="value"
      @input="handleInputQuantity"
      @blur="handleBlurQuantity"
      @focus="$event.target.select()"
      type="text"
      inputmode="numeric"
      pattern="[0-9]*"
      aria-label="Enter quantity"
      class="md:hidden mx-1 h-12 flex-1 min-w-0 rounded-xl border border-gray-200 bg-white px-3 text-center text-xl font-bold text-gray-900 shadow-sm outline-none transition-all focus:border-primary-500 focus:ring-2 focus:ring-primary-500"
    />
    <!-- Desktop: dropdown -->
    <select
      v-if="useDropdown"
      :value="value"
      @change="handleSelectQuantity"
      aria-label="Select quantity"
      class="hidden md:block mx-1 h-10 min-w-[4.5rem] rounded-xl border border-gray-200 bg-white px-3 text-center text-lg font-bold text-gray-900 shadow-sm outline-none transition-all focus:border-primary-500 focus:ring-2 focus:ring-primary-500"
    >
      <option
        v-for="quantityOption in quantityOptions"
        :key="quantityOption"
        :value="quantityOption"
      >
        {{ quantityOption }}
      </option>
    </select>
    <span
      v-if="!useDropdown"
      class="font-bold text-lg flex-1 md:flex-none md:w-10 text-center text-gray-900"
    >
      {{ value }}
    </span>
    <button
      @click="increment"
      class="rounded-md bg-white shadow-sm flex items-center justify-center hover:bg-gray-50 text-gray-600 transition-all"
      :class="useDropdown ? 'w-12 h-12 md:w-10 md:h-10' : 'w-10 h-10'"
    >
      <Plus :size="16" />
    </button>
  </div>
</template>

<script>
import {
  getQuantitySelectOptions,
  isPoloBistroUrl
} from "@/utils/customStoreRules";

export default {
  name: "QuantitySelector",
  props: {
    value: {
      type: Number,
      required: true,
      default: 1
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: null
    }
  },
  computed: {
    useDropdown() {
      return isPoloBistroUrl(this.$route?.path);
    },
    quantityOptions() {
      return getQuantitySelectOptions(this.value, {
        min: this.min,
        max: this.max
      });
    }
  },
  methods: {
    handleSelectQuantity(event) {
      this.$emit("input", Number(event.target.value));
    },
    handleInputQuantity(event) {
      const digits = event.target.value.replace(/[^0-9]/g, "");
      if (digits === "") return;
      let num = Number(digits);
      if (this.max && num > this.max) {
        num = this.max;
      }
      this.$emit("input", num);
    },
    handleBlurQuantity(event) {
      let num = Number(event.target.value.replace(/[^0-9]/g, ""));
      if (!num || num < this.min) {
        num = this.min;
      }
      if (this.max && num > this.max) {
        num = this.max;
      }
      // Re-sync the field in case the clamped value matches the current value
      // (no re-render would be triggered otherwise).
      event.target.value = num;
      this.$emit("input", num);
    },
    increment() {
      const newValue = this.value + 1;
      if (!this.max || newValue <= this.max) {
        this.$emit("input", newValue);
      }
    },
    decrement() {
      const newValue = Math.max(this.min, this.value - 1);
      this.$emit("input", newValue);
    }
  }
};
</script>
